import { WEAPONS } from './../constants';
import { Vector2, Vector3 } from 'three'
import { COMMANDERS } from '../../../../c.managers/LevelManager/store.d'
import { CHARACTER_ACTION, CHARACTER_STATES, CHARACTER_TYPES, CHARACTER_VARIANTS } from '../constants'
import { CharacterAction } from './CharacterActions'

class CharacterConfig {
  // 3d position from imported scene
  position?: Vector3
  // 2d coords for game grid
  coords: Vector2
  // type of the character
  type: CHARACTER_TYPES
  // unique key for React component
  key?: string
  // actions queue
  actions?: CharacterAction[]
  // current action
  currentAction?: CharacterAction
  // current state
  state?: CHARACTER_STATES
  // who is the owner
  owner?: COMMANDERS
  // tick time divisions in which run the actions
  tickDivisions: number[]
  // one of the available variants of minion
  variant: CHARACTER_VARIANTS

  team: CHARACTER_TYPES.JACK | CHARACTER_TYPES.WITCH

  weapon?: WEAPONS

  // ==================
  // level
  lv?: number
  // max lvl
  lv_max?: number
  // experience points, on 100 => lv++
  xp?: number
  // max xp
  xp_max?: number
  // health points, when 0 = KO
  hp?: number
  // max health
  hp_max?: number
  // charge time, on 100 can take turn
  ct?: number
  // max charge
  ct_max?: number
  // move
  mv?: number
  // max move
  mv_max?: number
  // speed
  sp?: number
  // max speed
  sp_max?: number
  // awaiting
  aw?: boolean
  

  constructor(config: CharacterConfig) {
    this.coords = config.coords || new Vector2(0, 0)
    this.position = config.position || new Vector3(0, 0, 0)
    this.type = config.type
    this.key = String(Math.random())
    this.actions = []
    this.state = CHARACTER_STATES.INACTIVE
    this.owner = config.owner
    this.tickDivisions = config.tickDivisions || []
    this.variant = config.variant || CHARACTER_VARIANTS.REGULAR
    this.team = config.team
    this.weapon = undefined

    this.mv = config.mv || 3
    this.lv = config.lv || 1 // level
    this.lv_max = config.lv_max || 100
    this.xp = config.xp || 1 // experience points, on 100 => lv++
    this.xp_max = config.xp_max || 100
    this.hp = config.hp || 15 // health points, when 0 = KO
    this.hp_max = config.hp_max || 15
    this.ct = config.ct || 100 // charge time, on 100 can take turn
    this.ct_max = config.ct_max || 100
    this.mv = config.mv || 8 // move
    this.mv_max = config.mv_max || 8
    this.sp = config.sp || 1 // speed
    this.sp_max = config.sp_max || 100
    // this.en = this ||config. 100, // energy
    // this.en_max = this ||config. 100,
    this.aw = config.aw || false // awaiting
  }
}

export default CharacterConfig
